<template>
  <div>
    <b-container class="py-3">
      <b-row>
        <b-col>

          <page-title :title="pageTitle" />

          <b-alert v-if="client && !client.isOffline" show variant="info">
            This client is not currently available offline.
          </b-alert>

          <div v-if="client && client.isOffline">
            <p>Do you want to check in {{ client.applicationUser.displayName }}?</p>
            <p>Once you check in a client, you will no longer be able to proctor their questionnaire offline (unless you check them out again). Once
              checked in, you'll be able to download their mitigation report.
            </p>
            <b-button @click="checkIn" v-if="client.isOffline" variant="primary">
              Check In
            </b-button>
          </div>

        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import marked from 'marked';
import AuthMixin from '../../Mixins/AuthMixin.vue'

export default {
  name: "SubscriberClientCheckIn",
  props: ['id'],
  mixins: [AuthMixin],
  data() {
    return {
      client: null,
    }
  },
  computed: {
    pageTitle: function () {
      if (!this.client)
        return 'Loading...';
      
      return 'Check In ' + this.client.applicationUser.firstName + ' ' + this.client.applicationUser.lastName;
    },
  },
  methods: {
    checkIn: function () {
      navigator.serviceWorker.controller.postMessage({
        action: 'checkIn',
        clientId: this.client.id,
        authToken: this.getAuthToken()
      });
    },
    load: function () {
      axios
        .get('/api/client/' + this.id + '?includes=applicationUser')
        .then(response => {
          this.client = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  watch: {
  },
  created() {
  },
  async mounted () {
    this.load();

    navigator.serviceWorker.onmessage = msg => {
      if (msg.data.action == 'checkedIn') {
        this.load();

        this.$parent.showToast('That client\'s offline data has been checked in.', {
          title: 'Offline Client Checked In',
          variant: 'success',
          autoHideDelay: 5000
        });

        this.$router.push('/');
      }
    }
  }
};
</script>